import { coerceBooleanProperty, coerceNumberProperty } from '@angular/cdk/coercion';
import {TemplateRef} from "@angular/core";
export type FunctionProp<T> = (...args: any[]) => T ;
export function isNotNil(value: any): boolean {
  return (typeof(value) !== 'undefined') && value !== null;
}
export function valueFunctionProp<T>(prop: FunctionProp<T>, ...args: any[]): T { // tslint:disable-line: no-any
  return typeof prop === 'function' ? prop(...args) : prop;
}
export function filterNotEmptyNode(node: Node): Node {
  if (node) {
    if ((node.nodeType === 1) && ((node as HTMLElement).outerHTML.toString().trim().length !== 0)) {
      // ELEMENT_NODE
      return node;
    } else if ((node.nodeType === 3) && (node.textContent.toString().trim().length !== 0)) {
      // TEXT_NODE
      return node;
    }
    return null;
  }
  return null;
}
export function isEmpty(element: HTMLElement): boolean {
  const nodes = element.childNodes;
  for (let i = 0; i < nodes.length; i++) {
    if (filterNotEmptyNode(nodes.item(i))) {
      return false;
    }
  }
  return true;
}

export function toBoolean(value: boolean | string): boolean {
  return coerceBooleanProperty(value);
}

export function isNonEmptyString(value: any): boolean { // tslint:disable-line:no-any
  return typeof value === 'string' && value !== '';
}

export function isTemplateRef(value: any): boolean { // tslint:disable-line:no-any
  return value instanceof TemplateRef;
}

export function toNumber<D>(value: number | string, fallback: D): number | D {
  return coerceNumberProperty(value, fallback);
}

export function InputBoolean(): any { // tslint:disable-line:no-any
  return function InputBooleanPropDecorator (target: object, name: string): void {
    // Add our own private prop
    const privatePropName = `$$__${name}`;

    if (Object.prototype.hasOwnProperty.call(target, privatePropName)) {
      console.warn(`The prop "${privatePropName}" is already exist, it will be overrided by InputBoolean decorator.`);
    }

    Object.defineProperty(target, privatePropName, {
      configurable: true,
      writable: true
    });

    Object.defineProperty(target, name, {
      get(): boolean {
        return this[ privatePropName ]; // tslint:disable-line:no-invalid-this
      },
      set(value: boolean | string): void {
        this[ privatePropName ] = toBoolean(value); // tslint:disable-line:no-invalid-this
      }
    });

  };
}

export interface NzCalendarI18nInterface {
  today: string;
  now: string;
  backToToday: string;
  ok: string;
  clear: string;
  month: string;
  year: string;
  timeSelect: string;
  dateSelect: string;
  monthSelect: string;
  yearSelect: string;
  decadeSelect: string;
  yearFormat: string;
  monthFormat?: string;
  dateFormat: string;
  dayFormat: string;
  dateTimeFormat: string;
  monthBeforeYear?: boolean;
  previousMonth: string;
  nextMonth: string;
  previousYear: string;
  nextYear: string;
  previousDecade: string;
  nextDecade: string;
  previousCentury: string;
  nextCentury: string;
}
